import React from 'react';
import styles from './CardGridHero.module.css';

const CardGridHero = ({
  subTitle,
  mainTitleLines,
  cardTitle,
  cardText,
  cardParagraphs,
  website,
  images,
}) => {
  const paragraphs = cardParagraphs ?? (cardText ? [cardText] : []);

  return (
  <section className={styles.heroSection}>
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <span className={styles.subTitle}>{subTitle}</span>
        <h1 className={styles.mainTitle}>
          {mainTitleLines[0]}
          <br />
          {mainTitleLines[1]}
        </h1>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>{cardTitle}</h3>
          {paragraphs.slice(0, 2).map((text, index) => (
            <p key={index} className={styles.cardText}>
              {text}
            </p>
          ))}
        </div>
        <a href={website.href} className={styles.website} target="_blank" rel="noreferrer">
          {website.label}
        </a>
      </div>
      <div className={styles.rightSection}>
        {images.map((image, index) => (
          <img key={index} src={image.src} alt={image.alt} className={styles.gridImage} />
        ))}
      </div>
    </div>
  </section>
  );
};

export default CardGridHero;
